export default __webpack_public_path__ + "static/media/servizi.2fbda906.png";